import React, { useState, useEffect } from 'react';
import {
  Box, Card, Grid, Typography, Button, Chip, TextField, MenuItem, IconButton, Tooltip,
  Checkbox,
  Radio,
  Divider,
  Select
} from '@mui/material';
import {
  Email, Phone, AssignmentInd, Work, Business, LocationOn, HomeWork, Apartment,
  Event,
  AccessTime,
  HighlightOff
} from '@mui/icons-material';
import { entrepriseCandidatureStatus, recruteurCandidatureStatus } from '../commun/constants/options';
import LoadingPopup from "../commun/LoadingPopup";
import { CircularProgressbar, buildStyles } from 'react-circular-progressbar';
import 'react-circular-progressbar/dist/styles.css';
import './CandidatureDetailsCommon.css';
import DownloadForOfflineIcon from '@mui/icons-material/DownloadForOffline';
import DeleteIcon from '@mui/icons-material/Delete';
import axios from 'axios';
import { Link, useNavigate } from 'react-router-dom';
import CustomDialog from './CustomDialog';
import { CheckCircle } from 'lucide-react';

import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs from 'dayjs';
  import { useRef } from 'react';
import CustomAlert from './CustomAlert';

const CandidatureDetailsCommon = ({
  HeaderComponent,
  headerProps,
  candidature,
  editedStatut,
  setEditedStatut,
  messageEntreprise,
  setMessageEntreprise,
  raisonRefus,
  setRaisonRefus,
  dateEntretien,
  setDateEntretien,
  bloqueSauvegarde,
  setBloqueSauvegarde,
  selectedTarif,          
  setSelectedTarif,
  onSave,
  onCancel,
  editable = false,
  API_BASE,
}) => {
  const [errorRaisonRefus, setErrorRaisonRefus] = useState('');
  const [errorDateEntretien, setErrorDateEntretien] = useState('');

  const [similarityScore, setSimilarityScore] = useState(null);
  const [loadingSimilarity, setLoadingSimilarity] = useState(false);
  const now = new Date().toISOString().slice(0, 16);
  const [creneauxAcceptes, setCreneauxAcceptes] = useState([]);
  // Rôle
  const userRole = headerProps?.userRole;
  const isRecruteur = userRole === 'recruteur';
  const isEntreprise = userRole === 'entreprise';
  const isAdmin = userRole === 'admin';
  
  const [dialogOpen, setDialogOpen] = useState(false);
  const [dialogTitle, setDialogTitle] = useState('');
  const [dialogContent, setDialogContent] = useState('');
  const [pendingSave, setPendingSave] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [hasRequested, setHasRequested] = useState(false);
  const [localSauvegardeDate, setLocalSauvegardeDate] = useState(null);

  const viewRef = useRef('day'); 
  const [alertMessage, setAlertMessage] = useState('');
  const [alertSeverity, setAlertSeverity] = useState('success');
  const [alertOpen, setAlertOpen] = useState(false);

  const tarifs = candidature?.tarifs || {};
  const contrats = Object.entries(tarifs);   
  const [showTarifError, setShowTarifError] = useState(false);
  const [isTarifDisabled, setIsTarifDisabled] = useState(false);

  messageEntreprise = messageEntreprise ?? '';
  raisonRefus = raisonRefus ?? '';
  dateEntretien = Array.isArray(dateEntretien) ? dateEntretien : [];
  setMessageEntreprise = setMessageEntreprise || (() => {});
  setRaisonRefus = setRaisonRefus || (() => {});
  setDateEntretien = setDateEntretien || (() => {});
  onSave = onSave || (() => {});
  onCancel = onCancel || (() => {});
  
  const isBlocked = Boolean(
   (candidature?.bloqueSauvegarde && 
    candidature?.sauvegardeDate &&
    (Date.now() - new Date(candidature.sauvegardeDate).getTime()) < 60 * 60 * 1000)
   ||
   (bloqueSauvegarde &&
    (!localSauvegardeDate ||
      (Date.now() - new Date(localSauvegardeDate).getTime()) < 60 * 60 * 1000))
 );

    //GRISER LISTE DE SATUTS 
    const FINAL_STATUSES = new Set(['Refusé avant entretien', 'Non retenu après entretien']);
    const [lockFinal, setLockFinal] = useState(FINAL_STATUSES.has(candidature?.statut));
    useEffect(() => {
      setLockFinal(FINAL_STATUSES.has(candidature?.statut));
    }, [candidature?.statut]);

    const persistedIndex = entrepriseCandidatureStatus.findIndex(s => s.value === candidature?.statut);


    useEffect(() => {
      if (isRecruteur && candidature?.creneauxAcceptes?.length) {
        setCreneauxAcceptes(candidature.creneauxAcceptes);
      }

      if (candidature) {
        setHasRequested(Boolean(candidature.demandeNouveauxCreneaux));
      }
    }, [candidature, isRecruteur]);
    
  useEffect(() => {
    const fetchSimilarity = async () => {
      if (
        !candidature?.missionId ||
        !candidature?.candidatId?._id ||
        similarityScore !== null
      ) return;
  
      try {
        setLoadingSimilarity(true);
        const response = await fetch(
          `${API_BASE}/api/matching/similarity/${candidature.missionId}/${candidature.candidatId._id}`
        );
  
        const data = await response.json();
  
        if (response.ok && typeof data.similarity === 'number') {
          setSimilarityScore(data.similarity);
        } else {
          console.warn("⚠️ Aucune similarité trouvée :", data.message || data);
        }
      } catch (error) {
        console.error("💥 Erreur lors du calcul de similarité :", error);
      } finally {
        setLoadingSimilarity(false);
      }
    };
  
    fetchSimilarity();
  }, [candidature?.missionId, candidature?.candidatId?._id, API_BASE]);
  
  if (!candidature)
    return <LoadingPopup open={!candidature} message="Chargement..." />;

  const devise = candidature?.devise || '€';
  const { candidatId, recruteurId, recruteur, mission, entreprise } = candidature;
  const nomComplet = candidatId?.prenomCandidat || candidatId?.nomCandidat
  ? `${candidatId?.prenomCandidat || ''} ${candidatId?.nomCandidat || ''}`.trim()
  : 'N/A';
  const trigramme = candidatId?.trigramme || '';
  const cvFileUrl = candidature?.cvId?.fileUrl || null;
  const recruiter = recruteur || recruteurId || {};
  const recruiterName = recruiter.nomComplet || `${recruiter.firstName || ''} ${recruiter.lastName || ''}`.trim();

  const statusOptions = isEntreprise ? entrepriseCandidatureStatus : recruteurCandidatureStatus;
  const matchedStatus = statusOptions.find((s) => s.value === editedStatut);
  let displayStatutLabel = matchedStatus ? matchedStatus.label : editedStatut;
  if (isEntreprise && (editedStatut === "A traiter" || editedStatut === "Candidature envoyée"))
    displayStatutLabel = "Candidature à traiter";
  if (isRecruteur && (editedStatut === "A traiter" || editedStatut === "Candidature à traiter"))
    displayStatutLabel = "Candidature envoyée";

  const handleSave = () => {
    let valid = true;
    setErrorRaisonRefus('');
    setErrorDateEntretien('');
    setShowTarifError(false);
    if (selectedTarif || candidature.tarifChoisi) {
      setIsTarifDisabled(true); 
    }    
    let title = '';
    let content = '';
  
    if (
      (editedStatut === 'Refusé avant entretien' || editedStatut === 'Non retenu après entretien') &&
      !raisonRefus.trim()
    ) {
      setErrorRaisonRefus('La raison du refus est obligatoire.');
      valid = false;
    }
  
    if (editedStatut === 'Recrutement confirmé' && !selectedTarif) {
      setShowTarifError(true);       
      valid = false;                  
    }
  
    if (editedStatut === 'Refusé avant entretien') {
      title = 'Candidature refusée avant entretien';
      content = `La candidature a été refusée pour la raison suivante :\n\n${raisonRefus.trim()}`;
    }
  
    if (editedStatut === 'Non retenu après entretien') {
      title = 'Candidat non retenu après entretien';
      content = `Le candidat n'a pas été retenu suite à l'entretien. Raison :\n\n${raisonRefus.trim()}`;
    }
    if (editedStatut === 'Accepté pour entretien') {
      const filled = dateEntretien.filter(d => d && d.trim());
      if (!isRecruteur && filled.length < 2) {
        setErrorDateEntretien("Vous devez proposer au moins deux dates d'entretien.");
        valid = false;
      } else if (filled.length === 0) {
        setErrorDateEntretien("La date d'entretien est obligatoire.");
        valid = false;
      } else {
        setDateEntretien(filled);
        setBloqueSauvegarde(true)
        title = 'Créneaux proposés';
        content = (
          <div style={{ textAlign: "center" }}>
            <p>Vous avez proposé les créneaux suivants :</p>
            <ul style={{ listStyleType: "none", padding: 0 }}>
              {filled.map((d, i) => (
                <li key={i} style={{ margin: "6px 0", fontWeight: 500 }}>
                  {new Date(d).toLocaleString("fr-FR", {
                    weekday: "short",
                    day: "2-digit",
                    month: "short",
                    year: "numeric",
                    hour: "2-digit",
                    minute: "2-digit",
                  })}
                </li>
              ))}
            </ul>
          </div>
        );
      }      
    }
  
    if (!valid) return;
  
    if (
      editedStatut === 'Refusé avant entretien' ||
      editedStatut === 'Non retenu après entretien'
    ) {
      title = 'Confirmation du refus';
      content = `Raison du refus :\n\n"${raisonRefus}"\n\nConfirmez-vous le refus ?`;
    }
  
    if (
      editedStatut !== 'Accepté pour entretien' &&
      editedStatut !== 'Refusé avant entretien' &&
      editedStatut !== 'Non retenu après entretien'
    ) {
      title = 'Confirmation du statut';
      content = `Confirmez-vous le changement de statut en :\n\n"${editedStatut}" ?`;
    }
  
    setDialogTitle(title);
    setDialogContent(content);
    setPendingSave(true);
    setDialogOpen(true);
  };
  

  const filteredStatusOptions = statusOptions.filter(
    step =>
      step.value?.toLowerCase() !== 'brouillon' &&
      !(isEntreprise && step.value === 'A traiter')
  );


  const allRaisonsRefus = [
    "Profil non adapté aux exigences du poste (compétences, expérience, formation insuffisantes ou inadaptées)",
    "Inadéquation avec les conditions du poste (mobilité, horaires, disponibilité, salaire…)",
    "Entretien non concluant (manque de clarté, incohérence, difficulté à se projeter)",
    "Candidat s’est désisté ou n’a pas donné suite",
    "Priorité donnée à une autre candidature jugée plus pertinente",
    "Le poste a été pourvu ou le recrutement a été suspendu"
  ];

  const raisonsFiltrees = editedStatut === 'Refusé avant entretien'
  ? allRaisonsRefus.filter((_, i) => i !== 2)
  : allRaisonsRefus;

  
  const handleConfirmerCreneaux = async () => {
    setIsSubmitting(true);
    setHasRequested(true)
    try {
      await axios.patch(`${API_BASE}/api/candidatures/${candidature._id}`, {
        statut: 'Accepté pour entretien',
        messageEntreprise,
        dateEntretien, 
        creneauxAcceptes,
      });
  
      setDialogTitle("Créneaux validés");
      setDialogContent("Les créneaux d'entretien ont été validés avec succès !");  
      setDialogOpen(true);
    } catch (error) {
      console.error("Erreur lors de la validation des créneaux :", error);
    }
  };

  const handleDemanderAjoutCreneaux = async () => {
    try {
      setIsSubmitting(true);
  
      await axios.patch(`${API_BASE}/api/candidatures/${candidature._id}`, {
        demandeNouveauxCreneaux: true,
      });
      setHasRequested(true);
      setDialogTitle("Demande envoyée");
      setDialogContent("Votre demande de nouveaux créneaux a été transmise à l’entreprise avec succès.");
      setDialogOpen(true);      
    } catch (error) {
      console.error("Erreur lors de la demande :", error);
    } finally {
      setIsSubmitting(false);
    }
  };
  
  
  return (
    <Box className="cdc2-root">
      {HeaderComponent && <HeaderComponent {...headerProps} />}
      <CustomAlert
        open={alertOpen}
        message={alertMessage}
        severity={alertSeverity}
        onClose={() => setAlertOpen(false)}
      />
      <CustomDialog
        open={dialogOpen}
        onClose={() => {
          setDialogOpen(false);
          setPendingSave(false);
        }}
        title={dialogTitle}
        content={dialogContent}
        actions={
          <>
          <Button
          onClick={() => {
            setDialogOpen(false);
            setPendingSave(false);
          }}
          color="secondary"
        >
          Fermer
        </Button>
          <Button
            onClick={() => {
              setDialogOpen(false);
              if (pendingSave) {
                setPendingSave(false);
                onSave();  
                candidature.statut = editedStatut;
                candidature.raisonRefus = raisonRefus;
                candidature.messageEntreprise = messageEntreprise;   
                candidature.tarif = selectedTarif;           
                setAlertMessage("Action confirmée avec succès !");
                setAlertSeverity("success");
                setAlertOpen(true); 
                setBloqueSauvegarde(true);
                setLocalSauvegardeDate(new Date().toISOString());   
                if (FINAL_STATUSES.has(editedStatut)) {
                  setLockFinal(true);
                }            
              }
            }}
            color="primary"
            autoFocus
          >
            Confirmer
          </Button>
          </>
        }
      />

      <Grid container className="cdc2-main-grid">
        {/* Partie gauche : fiche candidat */}
        <Grid item xs={12} md={6} className="cdc2-grid-half">
          <Card className="cdc2-card">
            <Box className="cdc2-header-row">
              <Typography variant="h5" className="cdc2-title">
                Fiche candidat : {trigramme}
              </Typography>
              <Chip
                label={displayStatutLabel}
                className={`cdc2-chip cdc2-chip-${matchedStatus?.value || 'default'}`}
              />
            </Box>
            {/* Référence + tarif + téléchargement */}
            <Box className="cdc2-info-row cdc2-ref-tarif-row" sx={{ alignItems: 'center' }}>
            
           {/* NON RECRUTEUR */}
            {!isRecruteur && editedStatut === "Recrutement confirmé" && (
              <Box display="flex" flexDirection="column" alignItems="flex-end" flex={1}>
                <Select
                  value={
                    selectedTarif ||
                    (candidature.tarifChoisi
                      ? `${candidature.tarifChoisi.type}:${candidature.tarifChoisi.prix}:${candidature.tarifChoisi.devise || '€'}`
                      : "")
                  }
                  onChange={(e) => {
                    setSelectedTarif(e.target.value);
                    setShowTarifError(false);
                  }}
                  displayEmpty
                  size="small"
                  sx={{ minWidth: 180 }}
                  error={!selectedTarif && !candidature.tarifChoisi}
                  disabled={Boolean(candidature.tarifChoisi) || isTarifDisabled} 
                >
                  <MenuItem value="" disabled>
                    Sélectionner un tarif
                  </MenuItem>
                  {contrats.map(([type, prix]) => (
                    <MenuItem
                      key={type}
                      value={`${type}:${prix}:${candidature.devise || '€'}`}
                    >
                      {`${type} - ${prix} ${candidature.devise || '€'}`}
                    </MenuItem>
                  ))}
                </Select>

                {!selectedTarif && !candidature.tarifChoisi && (
                  <Typography 
                    variant="caption" 
                    color="error" 
                    sx={{ mt: 0.5 }}
                  >
                    Veuillez sélectionner un tarif.
                  </Typography>
                )}
              </Box>
            )}

            {/* SI RECRUTEUR */}
              {isRecruteur && contrats.length > 0 && (
                <>
                  <span>
                    <span className="cdc2-label">Nom : </span>
                    <span className="cdc2-ref-value">{nomComplet}</span>
                  </span>

                  <Box
                    display="flex"
                    flexDirection="column"
                    alignItems="flex-end"
                    gap={1}
                  >
                    {contrats.map(([type, prix]) => {
                      const tarifValue = `${type}:${prix}:${devise || ''}`;
                      const selectedValue = candidature.tarifChoisi
                        ? `${candidature.tarifChoisi.type}:${candidature.tarifChoisi.prix}:${candidature.tarifChoisi.devise || ''}`
                        : null;

                      const isSelected = tarifValue === selectedValue;

                      return (
                        <Chip
                          key={type}
                          label={
                            isSelected
                              ? `✅ ${type} : ${prix} ${devise || ''}` 
                              : `${type} : ${prix} ${devise || ''}`
                          }
                          className={`cdc2-chip cdc2-chip-tarif ${isSelected ? "cdc2-chip-selected" : ""}`}
                          color={isSelected ? "success" : "default"}
                          variant={isSelected ? "filled" : "outlined"}
                        />
                      );
                    })}
                  </Box>
                </>
              )}

            </Box>

            <Box className="cdc2-info-row">
              <span className="cdc2-label">Date de candidature&nbsp;: </span>
              <span><strong>
                {(candidature.dateEnvoi) && !isNaN(new Date(candidature.dateEnvoi))
                  ? new Date(candidature.dateEnvoi).toLocaleDateString('fr-FR', { day: '2-digit', month: '2-digit', year: 'numeric' })
                  : '—'}
              </strong></span>
            </Box>

            {/* Simple rappel du dossier de compétences */}
                <Box className="cdc2-info-row">
          
                  <span className="cdc2-label">Dossier de compétences&nbsp;: </span>

                  {cvFileUrl && (
                  <Tooltip title="Télécharger le dossier de compétences">
                    <IconButton
                      size="small"
                      onClick={() => {
                        const win = window.open(`${API_BASE}${cvFileUrl}`, '_blank');
                        if (win) win.focus();
                      }}
                    >
                      <DownloadForOfflineIcon color="primary" />
                    </IconButton>
                  </Tooltip>
                )}
                </Box>
                {/* Bloc score de matching séparé */}
                {!loadingSimilarity && similarityScore !== null && (
                  <Box className="cdc2-matching-score-block">
                <Tooltip title="Ce score est basé sur l'analyse du CV et de la mission." arrow>
                  <Box className="cdc2-matching-title-with-icon">
                    <Typography variant="subtitle1" className="cdc2-matching-title">
                      Score de matching
                    </Typography>
                    <span className="cdc2-matching-info-icon">ℹ️</span>
                  </Box>
                </Tooltip>


              <Box className="cdc2-matching-circle">
                <CircularProgressbar
                  value={similarityScore * 100}
                  text={`${(similarityScore * 100).toFixed(0)}%`}
                  styles={buildStyles({
                    textSize: '22px',
                    pathColor:
                      similarityScore >= 0.75
                        ? '#4caf50'
                        : similarityScore >= 0.5
                        ? '#ffc107'
                        : '#f44336',
                    textColor: '#2d4376',
                    trailColor: '#e0e0e0',
                  })}
                />
              </Box>
              <Typography variant="caption" className="cdc2-matching-caption">
              Calculé par l’IA à partir du CV et de l’offre, le score reflète la pertinence entre le profil et le besoin en comparant les expériences, missions, technologies et compétences clés.
              </Typography>
            </Box>
                  )}


            {isEntreprise && (
              <Box className="cdc2-form-row">
                <TextField
                  select
                  label="Modifier le statut"
                  value={editedStatut}
                  onChange={(e) => {
                    if (lockFinal) return;          
                    setEditedStatut(e.target.value);
                    setErrorRaisonRefus('');
                    setErrorDateEntretien('');
                  }}
                  fullWidth
                  margin="normal"
                  className="cdc2-status-select"
                >
                  {filteredStatusOptions.map((step) => {
                    const optionIndex = entrepriseCandidatureStatus.findIndex(s => s.value === step.value);

                    return (
                      <MenuItem
                        key={step.value}
                        value={step.value}
                        disabled={
                          lockFinal
                            ? step.value !== editedStatut        
                            : optionIndex < persistedIndex          
                                                                   
                        }
                      >
                        {step.label}
                      </MenuItem>
                    );
                  })}
                </TextField>
              </Box>
            )}

            {(editedStatut === 'Refusé avant entretien' || editedStatut === 'Non retenu après entretien') && (
              <>
                {isRecruteur ? (
                  <TextField
                    label="Raison du refus"
                    value={candidature?.raisonRefus || 'Non précisée'}
                    fullWidth
                    margin="normal"
                    variant="outlined"
                    InputProps={{ readOnly: true }}
                  />
                ) : (
                  <TextField
                    select
                    label="Sélectionnez une raison de refus"
                    value={raisonRefus}
                    onChange={(e) => {
                      setRaisonRefus(e.target.value);
                      setErrorRaisonRefus('');
                    }}
                    fullWidth
                    margin="normal"
                    variant="outlined"
                    error={!!errorRaisonRefus}
                    helperText={errorRaisonRefus || 'Choisissez une raison principale du refus'}
                  >
                    {raisonsFiltrees.map((reason, idx) => (
                      <MenuItem key={idx} value={reason}>
                        {reason}
                      </MenuItem>
                    ))}
                  </TextField>
                )}
                <TextField
                  label="Message complémentaire à envoyer au candidat (optionnel)"
                  value={messageEntreprise}
                  onChange={(e) => {
                    setMessageEntreprise(e.target.value);
                    setErrorRaisonRefus('');
                  }}
                  fullWidth
                  margin="normal"
                  variant="outlined"
                  multiline
                  minRows={1}
                  disabled={isRecruteur}
                />
              </>
            )}
            
            {editedStatut === 'Accepté pour entretien' && !isAdmin && (
              <>
            {isAdmin && messageEntreprise && (
              <TextField
                label="Message de l'entreprise"
                value={messageEntreprise}
                onChange={e => setMessageEntreprise(e.target.value)}
                fullWidth
                margin="normal"
                variant="outlined"
                multiline
                minRows={1}
                disabled={isRecruteur}
              />
            )}

                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  {dateEntretien.map((date, index) => {
                    const OPEN = 8;
                    const CLOSE = 18;

                    const selectedDay = date ? dayjs(date) : null;
                    const now = dayjs();
                    const isToday = selectedDay ? selectedDay.isSame(now, 'day') : false;

                    const minTime = selectedDay
                      ? (isToday
                          ? selectedDay.hour(Math.max(now.hour(), OPEN)).minute(0).second(0)
                          : selectedDay.hour(OPEN).minute(0).second(0))
                      : undefined; 

                    const maxTime = selectedDay
                      ? selectedDay.hour(CLOSE).minute(0).second(0)
                      : undefined;

                    return (
                      <div key={index} style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 8 }}>
                        <DateTimePicker
                          ampm={false}
                          format="DD/MM/YYYY HH:mm"
                          openTo="day"
                          views={['day','hours','minutes']}
                          value={date ? dayjs(date) : null}
                          onViewChange={(v) => { viewRef.current = v; }}
                          onChange={(newValue) => {
                            if (!newValue || !newValue.isValid()) return;
                            const currentView = viewRef.current;
                            if (currentView === 'day') {
                              const pickedDay = newValue.startOf('day');
                              const makeTodaySafeHour = pickedDay.isSame(now, 'day')
                                ? Math.max(now.hour(), OPEN)
                                : OPEN;

                              const normalized = pickedDay.hour(makeTodaySafeHour).minute(0).second(0);

                              const iso = normalized.toISOString();
                              if (dateEntretien.some((d, i) => i !== index && d === iso)) {
                                setErrorDateEntretien("Cette date a déjà été choisie.");
                                return;
                              }
                              const next = [...dateEntretien];
                              next[index] = iso;
                              setDateEntretien(next);
                              setErrorDateEntretien('');
                              return;
                            }
                            const h = newValue.hour();
                            if (h < OPEN || h > CLOSE) {
                              setErrorDateEntretien("L'heure doit être entre 08:00 et 18:00");
                              return;
                            }

                            const iso = newValue.toISOString();
                            if (dateEntretien.some((d, i) => i !== index && d === iso)) {
                              setErrorDateEntretien("Cette date a déjà été choisie.");
                              return;
                            }

                            const next = [...dateEntretien];
                            next[index] = iso;
                            setDateEntretien(next);
                            setErrorDateEntretien('');
                          }}

                          disablePast
                          minDate={dayjs().startOf('day')}
                          shouldDisableDate={(d) => d.isBefore(dayjs().startOf('day'))}
                          {...(selectedDay ? { minTime, maxTime } : {})}
                          shouldDisableTime={(val, view) => {
                            if (view !== 'hours') return false;
                            const h = typeof val === 'number' ? val : dayjs(val).hour();
                            if (h < OPEN || h > CLOSE) return true;
                            if (selectedDay && selectedDay.isSame(now, 'day')) {
                              return h < now.hour();
                            }
                            return false;
                          }}

                          slotProps={{
                            textField: {
                              fullWidth: true,
                              margin: 'normal',
                              variant: 'outlined',
                              disabled: isRecruteur || (candidature.statut === 'Accepté pour entretien' && candidature.creneauxAcceptes?.length > 0),
                              error: !!errorDateEntretien,
                              helperText: index === 0 ? errorDateEntretien : '',
                            },
                          }}
                          disabled={isRecruteur || (candidature.statut === 'Accepté pour entretien' && candidature.creneauxAcceptes?.length > 0)}
                        />
                    {!isRecruteur && (
                      <IconButton
                        aria-label="Supprimer"
                        color="error"
                        onClick={() => {
                          const next = [...dateEntretien];
                          next.splice(index, 1); 
                          setDateEntretien(next);
                        }}
                        disabled={
                          isRecruteur ||
                          (candidature.statut === "Accepté pour entretien" &&
                            candidature.creneauxAcceptes?.length > 0  || isBlocked)
                        }
                      >
                        <DeleteIcon />
                      </IconButton>
                    )}
                      {isRecruteur && (
                      <Radio
                        checked={creneauxAcceptes[0] === date}
                        onChange={() => setCreneauxAcceptes([date])}
                        />
                      )}
                      </div>
                    );
                  })}
                </LocalizationProvider>

                { isEntreprise && (
                  <Button
                    variant="outlined"
                    onClick={() => setDateEntretien([...dateEntretien, ''])}
                    style={{ marginTop: '8px' }}
                    disabled={dateEntretien.length >= 3  || isBlocked || candidature.creneauxAcceptes?.length > 0 && !candidature?.demandeNouveauxCreneaux}
                  >
                    Ajouter une autre date
                  </Button>
                )}

              {isRecruteur && creneauxAcceptes.length > 0 && !isAdmin && (
                <Button
                  variant="contained"
                  color="primary"
                  onClick={handleConfirmerCreneaux}
                  style={{ marginTop: '16px' }}
                  disabled={candidature.creneauxAcceptes.length !== 0 || isSubmitting}
                >
                  Confirmer les créneaux sélectionnés
                </Button>
              )}
               {isEntreprise &&
                  candidature?.demandeNouveauxCreneaux &&
                  ((candidature.creneauxAcceptes?.length ?? 0) === 0) && (
                    <div className="creneaux-warning">
                      <strong>Le recruteur a demandé de nouvelles propositions de créneaux pour l'entretien.</strong>
                    </div>
                )}
              </>
            )}

            <Box className="cdc2-btn-row">
              <Button variant="outlined" color="primary" onClick={onCancel} className="cdc2-btn">Retour</Button>
              {editable && (
                <Button variant="contained" color="primary" onClick={handleSave}  className="cdc2-btn" 
                disabled={
                    (      (
                      candidature.statut === editedStatut && 
                      !(editedStatut === 'Accepté pour entretien' && candidature.demandeNouveauxCreneaux)
                    ) 
                    || ( editedStatut === 'Accepté pour entretien' && candidature.creneauxAcceptes?.length > 0)
                    || ( editedStatut === 'Accepté pour entretien' && isBlocked)
                     )
                }
                >
                  Sauvegarder
                </Button>
              )}
              {isRecruteur && editedStatut === 'Accepté pour entretien' &&(
                <Button
                  variant="outlined"
                  color="secondary"
                  onClick={handleDemanderAjoutCreneaux}
                  className="cdc2-btn"
                  disabled= {hasRequested || candidature.creneauxAcceptes.length !== 0}
                >
                  Demander un autre créneaux
                </Button>
              )}
            </Box>
          </Card>
        </Grid>
        {/* Partie droite : 2 cards alignées */}
        <Grid item xs={12} md={6} className="cdc2-grid-half">
          {/* Carte Infos Recruteur */}
          <Card className="recruiter-card">
            <Typography className="recruiter-title">Informations recruteur</Typography>
            <Box className="recruiter-info-row">
              <AssignmentInd className="recruiter-icon" />
              <span className="recruiter-label">Nom et prénom :</span>
              <Link to={`/profil/${recruiter.id}`} className="recruteur-link">
                <span>{recruiterName || 'N/A'}</span>
              </Link>
            </Box>
            <Box className="recruiter-info-row">
              <Email className="recruiter-icon" />
              <span className="recruiter-label">Email :</span>
              <span>{recruiter.email || 'N/A'}</span>
            </Box>
            <Box className="recruiter-info-row">
              <Phone className="recruiter-icon" />
              <span className="recruiter-label">Téléphone :</span>
              <span>{recruiter.phone || 'N/A'}</span>
            </Box>
          </Card>
          <Card className="recruiter-card">
            <Typography className="recruiter-title">Informations mission</Typography>

            <Box className="recruiter-info-row">
              <Work className="recruiter-icon" />
              <span className="recruiter-label">Nom de la mission :</span>
              <span>{mission?.nomMission || 'N/A'}</span>
            </Box>

            {/* <Box className="recruiter-info-row">
              <Business className="recruiter-icon" />
              <span className="recruiter-label">Entreprise :</span>
              <span>{entreprise?.NomEntreprise || 'N/A'}</span>
            </Box> */}

            <Box className="recruiter-info-row">
              <LocationOn className="recruiter-icon" />
              <span className="recruiter-label">Lieu :</span>
              <span>{mission?.lieuxTravail || 'N/A'}</span>
            </Box>

            <Box className="recruiter-info-row">
              <HomeWork className="recruiter-icon" />
              <span className="recruiter-label">Mode de travail :</span>
              <span>{mission?.modeTravail || 'N/A'}</span>
            </Box>
{/* 
            <Box className="recruiter-info-row">
              <Apartment className="recruiter-icon" />
              <span className="recruiter-label">Secteur :</span>
              <span>{mission?.secteur || 'N/A'}</span>
            </Box> */}
          </Card>

          {candidature?.statut === 'Accepté pour entretien' && (
            <Card className="recruiter-card" style={{ marginTop: '20px' }}>
              <Typography className="recruiter-title">Créneaux d'entretien</Typography>

              {/* Dates proposées */}
              {candidature.dateEntretien?.length > 0 ? (
                <Box className="recruiter-info-row" style={{ flexDirection: 'column', alignItems: 'flex-start' }}>
                  <Box display="flex" alignItems="center" gap={1}>
                    <Event className="recruiter-icon" />
                    <Typography variant="body2" style={{ fontWeight: 'bold' }}>Dates proposées :</Typography>
                  </Box>
                  <ul>
                    {candidature.dateEntretien.map((date, i) => (
                      <li key={i}>{new Date(date).toLocaleString('fr-FR')}</li>
                    ))}
                  </ul>
                </Box>
              ) : (
                <Typography variant="body2" style={{ color: '#888' }}>
                  Aucune date proposée pour le moment.
                </Typography>
              )}

              {/* Créneaux confirmés */}
              {candidature.creneauxAcceptes?.length > 0 ? (
                <Box className="recruiter-info-row" style={{ flexDirection: 'column', alignItems: 'flex-start', marginTop: '10px' }}>
                  <Box display="flex" alignItems="center" gap={1}>
                    <CheckCircle className="recruiter-icon" />
                    <Typography variant="body2" style={{ fontWeight: 'bold' }}>Créneaux confirmés :</Typography>
                  </Box>
                  <ul>
                    {candidature.creneauxAcceptes.map((date, i) => (
                      <li key={i}>{new Date(date).toLocaleString('fr-FR')}</li>
                    ))}
                  </ul>
                </Box>
              ) : (
                <Typography variant="body2" style={{ color: '#888', marginTop: '10px' }}>
                  Aucun créneau encore confirmé.
                </Typography>
              )}
            </Card>
          )}

<Card className="recruiter-card" style={{ marginTop: '20px', maxHeight: '400px', overflowY: 'auto' }}>
  <Typography className="recruiter-title">Historique</Typography>

  {candidature?.historique && candidature.historique.length > 0 ? (
    (() => {
      const histAsc = [...candidature.historique].sort(
        (a, b) => new Date(a.date) - new Date(b.date)
      );
      const histDesc = [...histAsc].reverse();
      return histDesc.map((entry, index) => {
        const idxInAsc = histAsc.findIndex(e => e === entry);
        const hadPrevProposal = histAsc
          .slice(0, idxInAsc)
          .some(e => e.statut === 'Accepté pour entretien' && (e.dateEntretien?.length ?? 0) > 0);

        const hadPrevAccept = histAsc
          .slice(0, idxInAsc)
          .some(e => (e.creneauxAcceptes?.length ?? 0) > 0);

        if (
          (entry.statut === 'Accepté pour entretien' &&
            (!entry.dateEntretien?.length && !entry.creneauxAcceptes?.length)) ||
          !entry.statut
        ) {
          return null;
        }

        return (
          <Box
            key={index}
            className="recruiter-info-row"
            style={{ flexDirection: 'column', alignItems: 'flex-start' }}
          >
            <Typography variant="body2" style={{ fontWeight: 'bold' }}>
              <AccessTime style={{ verticalAlign: 'middle', marginRight: 4 }} />
              {new Date(entry.date).toLocaleString('fr-FR')} — {
                (() => {
                  if (entry.statut === 'Accepté pour entretien') {
                    if ((entry.dateEntretien?.length ?? 0) > 0) {
                      return hadPrevProposal ? 'Nouveaux créneaux proposés' : 'Créneaux proposés par entreprise';
                    }
                    if ((entry.creneauxAcceptes?.length ?? 0) > 0) {
                      return hadPrevAccept ? 'Créneau modifié' : 'Créneau confirmé';
                    }
                    return '';  
                  }
                  return entry.statut || '';
                })()
              }
            </Typography>

            {entry.statut === 'Accepté pour entretien' && (
              <>
                {entry.dateEntretien?.length > 0 && (
                  <Box display="flex" alignItems="center" gap={1}>
                    <Event className="recruiter-icon" />
                    <Typography variant="body2">
                      {hadPrevProposal ? 'Nouveaux créneaux proposés :' : 'Créneaux proposés :'}
                    </Typography>
                  </Box>
                )}
                <ul>
                  {entry.dateEntretien?.map((date, i) => (
                    <li key={i}>{new Date(date).toLocaleString('fr-FR')}</li>
                  ))}
                </ul>

                {entry.creneauxAcceptes?.length > 0 && (
                  <>
                    <Box display="flex" alignItems="center" gap={1}>
                      <CheckCircle className="recruiter-icon" />
                      <Typography variant="body2">
                        {hadPrevAccept ? 'Créneau modifié :' : 'Créneau confirmé :'}
                      </Typography>
                    </Box>
                    <ul>
                      {entry.creneauxAcceptes.map((date, i) => (
                        <li key={i}>{new Date(date).toLocaleString('fr-FR')}</li>
                      ))}
                    </ul>
                  </>
                )}
              </>
            )}

            {entry.statut === 'Refusé avant entretien' && (
              <Box display="flex" alignItems="center" gap={1} style={{ color: 'red' }}>
                <HighlightOff className="recruiter-icon" />
                <Typography variant="body2">
                  Raison du refus : {entry.raisonRefus || 'Non spécifiée'}
                </Typography>
              </Box>
            )}

            {entry.statut === 'Recrutement confirmé' && (
              <Box display="flex" alignItems="center" gap={1}>
                <CheckCircle className="recruiter-icon" />
                <Typography variant="body2">
                  Le candidat a été recruté avec succès.
                </Typography>
              </Box>
            )}

            <Divider style={{ margin: '10px 0', width: '100%' }} />
          </Box>
        );
      });
    })()
  ) : (
    <Typography variant="body2" style={{ marginTop: '10px' }}>
      Aucun historique disponible.
    </Typography>
  )}
</Card>

          {/* Synthèse IA */}
          {/* {!isRecruteur && (
          <div className="summaryia-card">
            <SummaryIABox summary={iaSummary || "Aucune synthèse disponible."} />
          </div>
          )
        }  */}
          

        </Grid>
      </Grid>
    </Box>
  );
};

export default CandidatureDetailsCommon;
